export const isRouteForGpxAdmin = (route) => {
  return route.name.toLowerCase().includes('gpxadmin');
};
